import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Text from '@/common/view/Text';

const Box = styled.div<{ $inPopover?: boolean }>`
  padding: ${({ $inPopover }) => ($inPopover ? '5px 8px' : '9.6px 16px 9.6px 41.6px')};
  span {
    font-size: ${({ $inPopover }) => ($inPopover ? '11px' : '12.8px')};
  }
`;

export interface SubMenuItemProps {
  title: string;
  href: string;
  inPopover?: boolean;
}
const SubMenuItem: React.FC<SubMenuItemProps> = ({ title, href, inPopover }) => {
  const location = useLocation();
  const [active, setActive] = useState(false);
  useEffect(() => {
    setActive(location.pathname.includes(href));
  }, [location.pathname, href]);

  return (
    <Link to={href}>
      <Box $inPopover={inPopover}>
        <Text color={active ? 'blue50' : 'gray40'} typo="body3">
          {title}
        </Text>
      </Box>
    </Link>
  );
};

export default SubMenuItem;
